import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from "prop-types";

const PrivateRoute = ({ children }) => {
    const lmsToken = localStorage.getItem('lmsToken');
    const navigate = useNavigate();

    useEffect(() => {
        if (!lmsToken) {
            navigate('/login', { replace: true });
        }
    }, [lmsToken, navigate]);

    if (!lmsToken) {
        return null;
    }

    return children;
}

PrivateRoute.propTypes = {
    children: PropTypes.node
};

export default PrivateRoute;
